import { store } from "src/shared/store";
import { setHasUserInteracted } from "./globalSlice";

const waitForInteractionHandler = () => {
  store.dispatch(setHasUserInteracted(true));
  window.removeEventListener("focus", waitForInteractionHandler);
  window.removeEventListener("click", waitForInteractionHandler);
};

window.addEventListener("focus", waitForInteractionHandler);
window.addEventListener("click", waitForInteractionHandler);
